import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-3697d3e8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "truncate" };
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ETag',
    props: {
        size: { default: 'medium' },
        closable: { type: Boolean }
    },
    emits: ["close"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var tagSize = computed(function () {
            return props.size;
        });
        var handleClose = function (event) {
            event.stopPropagation();
            emit('close', event);
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createBlock(_Transition, { name: "e-zoom-in-center" }, {
                default: _withCtx(function () { return [
                    _createElementVNode("span", {
                        class: _normalizeClass([
                            'e-tag',
                            tagSize.value ? "e-tag--".concat(tagSize.value) : '',
                        ])
                    }, [
                        _createElementVNode("span", _hoisted_1, [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        (_ctx.closable)
                            ? (_openBlock(), _createBlock(_component_e_icon, {
                                key: 0,
                                "default-size": false,
                                class: "e-tag__close",
                                icon: "close",
                                onClick: handleClose
                            }))
                            : _createCommentVNode("", true)
                    ], 2)
                ]; }),
                _: 3
            }));
        };
    }
});
